import React, {useState} from 'react'
import {Button} from "primereact/button";
import ZoomSteuerung, {ZOOM_START_INDEX, ZOOM_STUFEN} from "./ZoomSteuerung";
import {BREITE_HANDY} from "./statistikWerte";
import {useVollbild} from "./browserVollbild";
import {LeisteAusblendenKnopf, LeisteEinblendenKnopf, useLeisteAusblendbar} from "./VollbildLeisteKnoepfe";

/**
 * Rahmen mit Vollbild-Knopf für einen Bereich der öffentlichen Ansicht (z.B. Gruppen, Runden im Schweizer System),
 * wie beim Turnierbaum: im Vollbild über die ganze Seite gelegt, mit Schließen. Gezoomt werden kann in der normalen
 * Ansicht und im Vollbild (gemeinsamer Wert), auf Handys startet der Zoom bei 80 %.
 */
export default function VollbildBereich({titel, appCall, children}) {

    const [vollbild, starteVollbild, schliesseVollbild] = useVollbild(appCall);
    // Leiste im Vollbild ausblendbar, damit mehr Platz für den Inhalt bleibt
    const [leisteAus, setLeisteAus] = useLeisteAusblendbar(vollbild);
    const [zoomIndex, setZoomIndex] = useState(() => window.matchMedia("(max-width: " + BREITE_HANDY + "px)").matches ? ZOOM_STUFEN.indexOf(0.8) : ZOOM_START_INDEX);

    if (vollbild) {
        return <div className={"dhpt-vollbild" + (leisteAus ? " dhpt-vollbild-ohne-leiste" : "")} role="dialog" aria-modal="true" aria-label={titel + " im Vollbild"}>
            {leisteAus && <LeisteEinblendenKnopf oben={true} onClick={() => setLeisteAus(false)}/>}
            <div className={"dhpt-vollbild-leiste" + (leisteAus ? " dhpt-ausgeblendet" : "")}>
                <span className="dhpt-vollbild-titel">{titel}</span>
                <ZoomSteuerung zoomIndex={zoomIndex} setZoomIndex={setZoomIndex}/>
                <LeisteAusblendenKnopf onClick={() => setLeisteAus(true)}/>
                <Button icon="pi pi-times" label="Schließen" className="p-button-secondary" onClick={schliesseVollbild}/>
            </div>
            <div className="dhpt-vollbild-inhalt">
                <div style={{zoom: ZOOM_STUFEN[zoomIndex]}}>{children}</div>
            </div>
        </div>
    }

    return <div>
        <div className="dhpt-baum-leiste">
            <ZoomSteuerung zoomIndex={zoomIndex} setZoomIndex={setZoomIndex} klein={true}/>
            <Button icon="pi pi-window-maximize" label="Vollbild" className="p-button-sm p-button-outlined dhpt-button-hell" onClick={starteVollbild}/>
        </div>
        {/* in der normalen Ansicht scrollt der Inhalt bei Bedarf seitlich, statt die Seite breiter zu machen */}
        <div style={{overflowX: "auto", maxWidth: "100%"}}>
            <div style={{zoom: ZOOM_STUFEN[zoomIndex]}}>{children}</div>
        </div>
    </div>
}
